import {Component, OnInit, Input, Inject} from '@angular/core';
import {OverlayPanel} from 'primeng/overlaypanel';
import {MatDialog} from '@angular/material/dialog';
import {LoginService, API_URL} from 'projects/core/src/public-api';
import {EmailService} from 'projects/app-misc/src/app/modules/email/data/email.service';
import {Router} from '@angular/router';
import {ProfileEditComponent} from '../../profile/profile-edit/profile-edit.component';
import {User} from 'projects/core/src/lib/login/data/user';
import {
  SendFeedBackDialogComponent
} from 'projects/app-misc/src/app/modules/feedback/view/send-feed-back-dialog/send-feed-back-dialog.component';
import {environment} from 'projects/desktop/src/environments/environment';
import {RouterService} from "../../../../../../core/src/lib/misc/router/router.service";

@Component({
  selector: 'app-profile-panel',
  templateUrl: './profile-panel.component.html',
  styleUrls: ['./profile-panel.component.scss']
})
export class ProfilePanelComponent implements OnInit {
  @Input()
  profileOP: OverlayPanel

  @Input()
  currentUser: User

  constructor(
    @Inject(API_URL) protected apiUrl: string,
    private dialog: MatDialog,
    private loginService: LoginService,
    private emailService: EmailService,
    private router: Router,
    private routerService: RouterService
  ) {
  }

  ngOnInit() {
    // this.subToCheckQb();
  }

  subToCheckQb() {
    // this.loginService.checkQBStatus().subscribe(emit => {
    // 	// console.log(emit)
    // })
  }

  doLogout(): void {
    this.profileOP.hide()
    this.loginService.logout()
      .subscribe(() => {
        this.router.navigate(['']).then(() => {
          // tslint:disable-next-line: deprecation
          location.reload();
        })
      })
  }

  openFeedBackDialog(): void {
    this.profileOP.hide()
    const dialogRef = this.dialog.open(SendFeedBackDialogComponent, {
      panelClass: 'send-feed-back-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  switchToCartTv(): void {
    location.assign(environment.systemCartTvUrl)
  }

  openEditProfileDialog(): void {
    this.profileOP.hide()
    const dialogRef = this.dialog.open(ProfileEditComponent, {
      data: this.currentUser,
      panelClass: 'edit-profile-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openQbAuth() {
    window.open(this.apiUrl + `/login/qb/start-auth`, '_blank');
  }

  routeTo(s: string) {
    this.routerService.routeTo(s)
  }

  routeToWithRefresh(s: string) {
    this.routerService.routeToWithRefresh(s)
  }
}
